export default __webpack_public_path__ + "static/media/downAccordion.d9881e7f.svg";